import { ExitObjectOutputType, LegacyOption } from '@app/types';

const exitObjectOutputTypeLabels: Record<ExitObjectOutputType, string> = {
  [ExitObjectOutputType.intent]: 'Intent',
  [ExitObjectOutputType.value]: 'Value',
  [ExitObjectOutputType.variable]: 'Variable Reference'
};

export const exitObjectOutputTypeOptions: LegacyOption<ExitObjectOutputType>[] = (
  Object.entries(exitObjectOutputTypeLabels).map(([type, label]) => {
    return {
      name: label,
      value: type as ExitObjectOutputType
    };
  })
);
